import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators ,FormGroup, FormControl} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LeavesService } from '../../services/leaves.service';

@Component({
  selector: 'app-leaves-status',
  templateUrl: './leaves-status.component.html',
  styleUrls: ['./leaves-status.component.css']
})
export class LeavesStatusComponent implements OnInit {

  leaveStatus=  new FormGroup({
    leave_status_reason: new FormControl(),
    leave_status: new FormControl()


  });
  id: string;
  public isShowAlert: boolean = false;
  public isShowErrorAlert: boolean = false;
  
  public userLeaveDetails: any;
  public userLeaveBalance:any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private leaveService: LeavesService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.leaveAppliedUserDetails(); // Fetch user details when ID changes
    });
  
    // Form setup moved inside the subscribe block
    this.leaveService.getViewLeaveDetails({ id: this.id }).subscribe(
      async (res) => {
        this.userLeaveDetails = await res.body.leavesData;
        this.userLeaveBalance = await res.body.leaveBalance;

        console.log(`Responsive Data :: `, this.userLeaveDetails);
  
        // Initialize form after retrieving data
        this.leaveStatus = this.fb.group({
          leave_status_reason: [this.userLeaveDetails?.leave_status_reason || '', Validators.required],
          leave_status: [this.userLeaveDetails?.leave_status || '', Validators.required],
          id: [this.id]
        });
      }
    );
  }
  
  initializeForm() {
    this.leaveStatus = this.fb.group({
      leave_status_reason: [this.userLeaveDetails?.leave_status_reason || '', Validators.required],
      leave_status: ['', Validators.required],
      id: [this.id]
    });
  }
  get leaveStatusValidate() {
    return this.leaveStatus.controls;
  }

  closeAlertMessage(): void {
    setTimeout(() => {
      this.isShowAlert = false;
      this.router.navigate(['/leaves']); // Redirect to successUrl
    }, 2000);
  }
  closeAlertErrorMessage(): void {
    setTimeout(() => {
      this.isShowErrorAlert = false;
      // this.router.navigate(['/leaves']); // Redirect to successUrl
    }, 2000);
  }

  updateLeaveStatusReason(event: any) {
    if (this.userLeaveDetails) {
      this.userLeaveDetails.leave_status_reason = event.target.value;
    }
  }
  addLeaveStatusFilterParameters(): Object {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
    });
    let filterParams = {};
    filterParams["sort"] = "-id";
    filterParams["id"] = this.id;
    return filterParams;
  }

   leaveAppliedUserDetails(): void {
    let filterParams = this.addLeaveStatusFilterParameters();
    this.leaveService.getViewLeaveDetails(filterParams).subscribe(
      async (res) => {
        this.userLeaveDetails = await res.body.leavesData;
        this.userLeaveBalance = await res.body.leaveBalance;

        console.log(`Responsive Data :: `, this.userLeaveDetails);
      }
    );
  }
  updateLeaveStatus(event: any) {
    if (this.userLeaveDetails) {
      this.userLeaveDetails.leave_status = event.target.value;
    }
  }
  

  leaveStatusSubmit(): void {
    if (this.leaveStatus.invalid) {
      return;
    }
    
  const { leave_status_reason, leave_status } = this.leaveStatus.value;

  if (leave_status_reason === undefined || leave_status === undefined) {
    console.error('Leave status or reason is undefined.');
    return;
  }

  const updatedLeaveStatus = {
    leave_status_reason,
    leave_status,
    id: this.id
  };

    this.leaveStatus.patchValue({
      leave_status_reason: this.leaveStatus.value.leave_status_reason,
      leave_status: this.leaveStatus.value.leave_status,
      id: this.id
    });

    this.leaveService.getUpdateLeave(this.leaveStatus.value).subscribe(
      (res: any) => {
        if (res.status === "success") {
          this.isShowAlert = true;
          this.closeAlertMessage();
        }else{
            this.isShowErrorAlert = true;
            this.closeAlertErrorMessage();
        }
        console.log('Data loaded successfully:', res);
      },
      (error) => {
        if (error.status === 404) {
          console.error('Not found:', error);
        } else if (error.status === 500) {
          console.error('Internal server error:', error);
        } else {
          console.error('Unknown error:', error);
        }
      }
    );
  }
}
